import { createContext, useContext, useState, useCallback } from "react";

const translations = {
  fr: {
    tagline: "La plateforme des communautés Shia",
    hero_title: "Toute votre communauté. Une seule plateforme.",
    hero_sub: "SHIALOC permet aux associations, centres islamiques et mosquées Shia de gérer événements, membres, calendrier Hijri et communications dans un espace moderne et unifié.",
    get_started: "Commencer",
    explore_assocs: "Découvrir les associations",
    login: "Connexion",
    register: "Créer un compte",
    logout: "Déconnexion",
    email: "Email",
    password: "Mot de passe",
    name: "Nom complet",
    continue_google: "Continuer avec Google",
    or: "ou",
    no_account: "Pas encore de compte ?",
    have_account: "Déjà un compte ?",
    features_title: "Tout ce dont votre association a besoin",
    feature_calendar: "Calendrier Grégorien + Hijri",
    feature_calendar_desc: "Double affichage des dates, ajustable selon les décisions locales sur les mois lunaires.",
    feature_mosques: "Mosquées illimitées",
    feature_mosques_desc: "Gérez toutes vos mosquées et centres avec horaires, contacts et programmes.",
    feature_events: "Événements & inscriptions",
    feature_events_desc: "Publiez vos programmes, gérez les inscriptions et partagez en un clic.",
    feature_notifs: "Notifications",
    feature_notifs_desc: "Vos membres sont informés en temps réel de chaque nouveau programme.",
    feature_multitenant: "Multi-tenant",
    feature_multitenant_desc: "Chaque association possède son espace privé, ses couleurs et son identité.",
    feature_ai: "Assistant IA",
    feature_ai_desc: "Génération automatique de descriptions d'événements en français ou anglais.",
    associations: "Associations",
    members: "membres",
    mosques: "Mosquées",
    mosque: "Mosquée",
    events: "Événements",
    event: "Événement",
    calendar: "Calendrier",
    announcements: "Annonces",
    upcoming_events: "Prochains événements",
    see_all: "Voir tout",
    join: "Rejoindre",
    joined: "Membre",
    follow: "Suivre",
    following: "Suivi",
    today: "Aujourd'hui",
    month: "Mois",
    week: "Semaine",
    agenda: "Agenda",
    no_events: "Aucun événement sur cette période",
    register_event: "S'inscrire",
    unregister_event: "Se désinscrire",
    registered: "Inscrit",
    participants: "participants",
    share: "Partager",
    link_copied: "Lien copié !",
    add_to_calendar: "Ajouter à l'agenda",
    calendar_sync: "Synchroniser mon agenda",
    calendar_subscribe_label: "Abonnement par lien (URL)",
    calendar_export_label: "Téléchargement ponctuel (.ics)",
    subscribe_google: "Synchroniser avec Google Calendar",
    subscribe_apple: "Synchroniser avec Apple Calendar",
    copy_feed: "Copier le lien de synchronisation",
    feed_copied: "Lien copié !",
    export_month: "Exporter ce mois",
    export_year: "Exporter toute l'année",
    google_calendar: "Google Calendar",
    apple_calendar: "Apple Calendar (ICS)",
    outlook: "Outlook",
    download_ics: "Télécharger ICS",
    livestream: "Regarder en direct",
    location: "Lieu",
    date: "Date",
    dashboard: "Tableau de bord",
    overview: "Vue d'ensemble",
    settings: "Paramètres",
    save: "Enregistrer",
    saved: "Enregistré",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    add_event: "Nouvel événement",
    add_mosque: "Nouvelle mosquée",
    add_announcement: "Nouvelle annonce",
    add_admin: "Ajouter un admin",
    title: "Titre",
    description: "Description",
    category: "Catégorie",
    start_time: "Début",
    end_time: "Fin",
    image_url: "URL de l'image",
    capacity: "Capacité (optionnel)",
    livestream_url: "URL du direct (optionnel)",
    generate_ai: "Générer avec l'IA",
    generating: "Génération...",
    address: "Adresse",
    phone: "Téléphone",
    website: "Site web",
    color: "Couleur",
    hours: "Horaires",
    content: "Contenu",
    role: "Rôle",
    joined_at: "Inscrit le",
    hijri_offset: "Ajustement Hijri (jours)",
    hijri_offset_desc: "Décalez le calendrier Hijri selon les décisions locales sur l'observation lunaire.",
    primary_color: "Couleur principale",
    banner_url: "URL de la bannière",
    logo_url: "URL du logo",
    city: "Ville",
    country: "Pays",
    language: "Langue",
    timezone: "Fuseau horaire",
    currency: "Devise",
    notifications: "Notifications",
    mark_all_read: "Tout marquer comme lu",
    no_notifications: "Aucune notification",
    super_admin: "Super Admin",
    association_admin: "Admin Association",
    mosque_admin: "Admin Mosquée",
    member: "Membre",
    total_users: "Utilisateurs",
    total_registrations: "Inscriptions",
    new_association: "Nouvelle association",
    assoc_name: "Nom de l'association",
    slug: "Slug (URL)",
    admin_name: "Nom de l'admin",
    admin_email: "Email de l'admin",
    admin_password: "Mot de passe de l'admin",
    assigned_mosques: "Mosquées attribuées",
    confirm_delete: "Confirmer la suppression ?",
    user_search_title: "Rechercher un utilisateur",
    user_search_placeholder: "Rechercher par email (min. 3 caractères)…",
    user_search_btn: "Rechercher",
    user_deleted: "Utilisateur supprimé",
    role_member_label: "Membre",
    role_moderator_label: "Modérateur",
    role_super_admin_label: "Super Admin",
    login_required: "Connectez-vous pour continuer",
    powered_by: "Propulsé par SHIALOC",
    cat_prayer: "Prière",
    cat_lecture: "Conférence",
    cat_majlis: "Majlis",
    cat_dua: "Dua",
    cat_education: "Éducation",
    cat_community: "Communauté",
    cat_ramadan: "Ramadan",
    cat_muharram: "Muharram",
    cat_other: "Autre",
    cat_madressa: "Madressa",
    cat_outing: "Sortie",
    cat_sport: "Sport",
    cat_women: "Programme femmes",
    all_categories: "Toutes",
    all_mosques: "Toutes les mosquées",
    view_full_calendar: "Voir le calendrier complet",
    event_categories_title: "Catégories d'événements",
    custom_categories_hint: "Ajoutez vos propres catégories (ex: Cours de tajwid). Elles s'ajoutent aux catégories par défaut dans le formulaire d'événement.",
    category_colors_hint: "Cliquez sur la pastille pour choisir la couleur de chaque catégorie (affichée sur le calendrier et les cartes d'événements). Sans couleur personnalisée, c'est la couleur de la mosquée qui s'applique.",
    new_category_placeholder: "Nouvelle catégorie...",
    add_category_btn: "Ajouter",
    chatbot_title: "Assistant du programme",
    chatbot_intro: "Salam ! Posez-moi une question sur le programme des événements. Par exemple :",
    chatbot_placeholder: "Posez votre question...",
    chatbot_sugg_1: "Quel est le programme cette semaine ?",
    chatbot_sugg_2: "Y a-t-il un majliss ce week-end ?",
    chatbot_sugg_3: "Quels sont les prochains événements ?",
    chatbot_error: "Désolé, une erreur est survenue. Réessayez.",
    chatbot_view_event: "Voir la fiche",
    chatbot_register: "S'inscrire",
    chatbot_registered: "Inscrit",
    chatbot_login_to_register: "Connectez-vous pour vous inscrire",
    chatbot_register_success: "Inscription confirmée !",
    chatbot_unregister_success: "Inscription annulée",
    import_pdf: "Importer un PDF",
    import_pdf_title: "Importer un programme PDF",
    import_pdf_hint: "Envoyez le programme de votre association ou mosquée en PDF (texte ou scanné). L'IA détecte automatiquement les événements — vous validez avant création.",
    import_select_file: "Choisir un fichier PDF",
    import_analyzing: "Analyse du PDF par l'IA en cours…",
    import_events_found: "{n} événement(s) détecté(s) — vérifiez, ajustez puis validez :",
    import_shift_j1: "Décaler les événements à la veille (J-1) — la soirée a lieu la veille de la date indiquée",
    import_no_mosque: "Créez d'abord une mosquée (onglet Mosquées) avant d'importer un programme PDF.",
    google_sync_hint: "Agenda ajouté ! Il apparaît dans « Autres agendas » sur calendar.google.com. Sur l'appli mobile Google Agenda : Paramètres → votre compte → nom de l'association → activez la synchronisation. Les événements peuvent mettre quelques minutes à s'afficher.",
    sync_help: "Aide synchronisation",
    gcal_auto_label: "Synchronisation automatique",
    gcal_connect: "Connecter mon agenda Google",
    gcal_connected: "Agenda Google connecté",
    gcal_disconnect: "Déconnecter l'agenda Google",
    gcal_connected_toast: "Agenda Google connecté ! Les événements s'ajoutent automatiquement dans votre agenda (y compris sur Android).",
    gcal_disconnected_toast: "Agenda Google déconnecté. Les événements synchronisés seront retirés de votre agenda.",
    gcal_error_toast: "La connexion Google a échoué. Réessayez.",
    gcal_sync_now: "Resynchroniser maintenant",
    gcal_syncing: "Synchronisation en cours…",
    gcal_sync_done: "{n} événement(s) synchronisé(s) dans votre agenda Google !",
    gcal_sync_partial: "{n} événement(s) synchronisé(s)",
    gcal_enable_assoc: "Activer la synchro pour cette association",
    follow: "Suivre",
    following: "Suivi",
    guest_followed_toast: "Association suivie — enregistré sur cet appareil, aucun compte requis",
    guest_unfollowed_toast: "Association retirée de vos suivis",
    my_followed_assocs: "Mes associations suivies",
    guest_device_note: "Enregistré sur cet appareil",
    privacy_link: "Politique de confidentialité",
    delete_all_events: "Tout supprimer",
    delete_all_confirm: "Supprimer TOUS les événements ({n}) ? Cette action est irréversible et les retirera aussi des agendas Google synchronisés.",
    deleted_n_events: "{n} événement(s) supprimé(s)",
    copy_link: "Copier le lien",
    import_none_found: "Aucun événement détecté dans ce PDF.",
    import_create_n: "Créer {n} événement(s)",
    import_other_file: "Autre fichier",
    import_success: "{n} événement(s) créé(s) avec succès !",
    view_mosque: "Voir la mosquée",
    contact: "Contact",
    open_map: "Voir sur la carte",
    back: "Retour",
    full: "Complet",
    visit_page: "Visiter la page",
    landing_footer: "Conçu pour les associations, centres islamiques et mosquées Shia du monde entier.",
    day: "Jour",
    timeline: "Timeline",
    year: "Année",
    gallery: "Galerie",
    upload_photo: "Ajouter une photo",
    caption: "Légende",
    no_photos: "Aucune photo pour le moment",
    moderator: "Modérateur",
    my_profile: "Mon profil",
    phone_number: "Téléphone",
    phone_hint: "Format international, ex : +33612345678",
    notify_email_label: "Notifications par email",
    push_notifications: "Notifications push (navigateur)",
    push_denied: "Permission refusée par le navigateur",
    notify_members_btn: "Notifier les membres",
    notification_sent: "Notification envoyée à {n} membre(s)",
    push_banner_text: "Ne manquez aucun événement : activez les notifications push.",
    push_banner_btn: "Activer",
    audience_mosque: "Abonnés de la mosquée",
    audience_all: "Toute l'association",
    reminder_hint: "Les inscrits reçoivent un rappel automatique 1h avant l'événement.",
    feed: "Fil d'actualité",
    announcement: "Annonce",
    photo: "Photo",
    write_comment: "Écrire un commentaire...",
    comments: "Commentaires",
    no_feed_title: "Votre fil est vide",
    no_feed_text: "Rejoignez une association pour voir ses événements, annonces et photos ici.",
    become_member: "Devenir membre",
    mosque_member: "Membre",
    mosque_members: "membres de la mosquée",
    mosque_member_singular: "membre de la mosquée",
    following_success: "Vous êtes maintenant membre de cette mosquée. Vous recevrez ses notifications.",
    unfollowed: "Vous ne suivez plus cette mosquée.",
    post: "Publication",
    post_placeholder: "Partagez une actualité avec vos membres...",
    publish: "Publier",
    post_published: "Publication ajoutée au fil",
    post_deleted: "Publication supprimée",
    all_members: "Tous les membres",
    no_members_yet: "Aucun membre pour le moment",
    my_mosque: "Ma mosquée",
    other_mosques: "Autres mosquées",
    next_event: "Prochain événement",
    no_upcoming_event: "Aucun événement à venir",
    prayer_times: "Horaires de prière",
    prayer_fajr: "Fajr",
    prayer_sunrise: "Lever",
    prayer_dhuhr: "Dhuhr",
    prayer_asr: "Asr",
    prayer_maghrib: "Maghrib",
    prayer_isha: "Isha",
    forgot_password: "Mot de passe oublié ?",
    forgot_password_title: "Réinitialiser le mot de passe",
    forgot_password_text: "Entrez votre email, nous vous enverrons un lien de réinitialisation valable 1 heure.",
    send_reset_link: "Envoyer le lien",
    reset_sent: "Si un compte existe avec cet email, un lien de réinitialisation a été envoyé. Vérifiez votre boîte mail.",
    new_password: "Nouveau mot de passe",
    admin_accounts: "Comptes administrateurs",
    change_password_btn: "Changer le mot de passe",
    password_updated: "Mot de passe mis à jour !",
    pwd_min_hint: "8 caractères minimum",
    role_association_admin: "Admin association",
    role_mosque_admin: "Responsable mosquée",
    confirm_password: "Confirmer le mot de passe",
    passwords_mismatch: "Les mots de passe ne correspondent pas",
    reset_success: "Mot de passe réinitialisé ! Vous pouvez vous connecter.",
    reset_password_btn: "Réinitialiser",
    reset_link_invalid: "Lien invalide ou incomplet. Veuillez refaire une demande.",
    back_to_login: "Retour à la connexion",
    event_banners: "Bannières (une ou plusieurs images)",
    add_image: "Ajouter une image",
    main_image: "Principale",
    timezone_search: "Rechercher un fuseau horaire...",
    no_results: "Aucun résultat",
    invite_members: "Inviter",
    invite_message: "Rejoignez {name} sur SHIALOC ! Événements, horaires de prière et actualités de la communauté :",
    invite_dialog_text: "Partagez le lien de {name} avec vos proches.",
    copy_link: "Copier le lien",
    error_generic: "Une erreur est survenue",
    join_mosque_prompt: "Créez un compte ou connectez-vous pour devenir membre de {name}.",
    social_links: "Réseaux sociaux",
    gps_coords: "Coordonnées GPS",
    gps_hint: "Utilisées pour des horaires de prière précis selon la localisation exacte.",
    live_broadcast: "Diffusion en direct",
    watch_on: "Regarder sur {platform}",
    notify_live: "Notifier le direct",
    live_notified: "{count} membres notifiés du direct !",
    guest_interact_prompt: "Créez un compte pour interagir avec la communauté",
    choose_continue: "Comment souhaitez-vous continuer ?",
    continue_guest: "Continuer en tant qu'invité",
    guest_desc: "Explorez les associations, mosquées, événements et horaires de prière sans compte.",
    login_or_register: "Se connecter ou créer un compte",
    member_desc: "Devenez membre : likes, commentaires, inscriptions aux événements et notifications.",
    register_association: "Inscrire mon association",
    register_association_cta_desc: "Votre association n'est pas encore sur SHIALOC ? Faites une demande.",
    register_association_title: "Inscrire votre association",
    register_association_sub: "Remplissez ce formulaire. Le super administrateur validera votre demande, puis vous pourrez vous connecter avec vos identifiants.",
    your_credentials: "Vos identifiants de connexion (après approbation)",
    message_optional: "Message (optionnel)",
    send_request: "Envoyer la demande",
    assoc_request_sent_title: "Demande envoyée !",
    assoc_request_sent_text: "Votre demande a été transmise au super administrateur. Dès qu'elle sera approuvée, vous pourrez vous connecter avec l'email et le mot de passe choisis.",
    pending_requests: "Demandes d'inscription",
    approve: "Approuver",
    reject: "Refuser",
    request_approved: "Demande approuvée — association créée",
    request_rejected: "Demande refusée",
    req_pending: "En attente",
    req_approved: "Approuvée",
    req_rejected: "Refusée",
    account_user: "Utilisateur",
    account_assoc: "Association",
    mosque_manager: "Responsable",
    designate_manager: "Désigner un responsable",
    designate_manager_hint: "Un compte « Admin de mosquée » sera créé avec ces identifiants. Si l'email correspond déjà à un responsable de votre association, cette mosquée lui sera simplement ajoutée (mot de passe ignoré).",
    manager_designated: "Responsable désigné !",
  },
  en: {
    tagline: "The platform for Shia communities",
    hero_title: "Your whole community. One platform.",
    hero_sub: "SHIALOC lets Shia associations, Islamic centers and mosques manage events, members, the Hijri calendar and communications in one modern, unified space.",
    get_started: "Get started",
    explore_assocs: "Explore associations",
    login: "Log in",
    register: "Sign up",
    logout: "Log out",
    email: "Email",
    password: "Password",
    name: "Full name",
    continue_google: "Continue with Google",
    or: "or",
    no_account: "No account yet?",
    have_account: "Already have an account?",
    features_title: "Everything your association needs",
    feature_calendar: "Gregorian + Hijri calendar",
    feature_calendar_desc: "Dual date display, adjustable to local decisions on lunar months.",
    feature_mosques: "Unlimited mosques",
    feature_mosques_desc: "Manage all your mosques and centers with hours, contacts and programs.",
    feature_events: "Events & registrations",
    feature_events_desc: "Publish programs, manage registrations and share in one click.",
    feature_notifs: "Notifications",
    feature_notifs_desc: "Your members are informed in real time of every new program.",
    feature_multitenant: "Multi-tenant",
    feature_multitenant_desc: "Each association gets its own private space, colors and identity.",
    feature_ai: "AI assistant",
    feature_ai_desc: "Automatic event description generation in French or English.",
    associations: "Associations",
    members: "members",
    mosques: "Mosques",
    mosque: "Mosque",
    events: "Events",
    event: "Event",
    calendar: "Calendar",
    announcements: "Announcements",
    upcoming_events: "Upcoming events",
    see_all: "See all",
    join: "Join",
    joined: "Member",
    follow: "Follow",
    following: "Following",
    today: "Today",
    month: "Month",
    week: "Week",
    agenda: "Agenda",
    no_events: "No events in this period",
    register_event: "Register",
    unregister_event: "Unregister",
    registered: "Registered",
    participants: "participants",
    share: "Share",
    link_copied: "Link copied!",
    add_to_calendar: "Add to calendar",
    calendar_sync: "Sync my calendar",
    calendar_subscribe_label: "Link subscription (URL)",
    calendar_export_label: "One-time download (.ics)",
    subscribe_google: "Sync with Google Calendar",
    subscribe_apple: "Sync with Apple Calendar",
    copy_feed: "Copy sync link",
    feed_copied: "Link copied!",
    export_month: "Export this month",
    export_year: "Export the whole year",
    google_calendar: "Google Calendar",
    apple_calendar: "Apple Calendar (ICS)",
    outlook: "Outlook",
    download_ics: "Download ICS",
    livestream: "Watch live",
    location: "Location",
    date: "Date",
    dashboard: "Dashboard",
    overview: "Overview",
    settings: "Settings",
    save: "Save",
    saved: "Saved",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    add_event: "New event",
    add_mosque: "New mosque",
    add_announcement: "New announcement",
    add_admin: "Add admin",
    title: "Title",
    description: "Description",
    category: "Category",
    start_time: "Start",
    end_time: "End",
    image_url: "Image URL",
    capacity: "Capacity (optional)",
    livestream_url: "Livestream URL (optional)",
    generate_ai: "Generate with AI",
    generating: "Generating...",
    address: "Address",
    phone: "Phone",
    website: "Website",
    color: "Color",
    hours: "Hours",
    content: "Content",
    role: "Role",
    joined_at: "Joined",
    hijri_offset: "Hijri adjustment (days)",
    hijri_offset_desc: "Shift the Hijri calendar according to local moon-sighting decisions.",
    primary_color: "Primary color",
    banner_url: "Banner URL",
    logo_url: "Logo URL",
    city: "City",
    country: "Country",
    language: "Language",
    timezone: "Timezone",
    currency: "Currency",
    notifications: "Notifications",
    mark_all_read: "Mark all as read",
    no_notifications: "No notifications",
    super_admin: "Super Admin",
    association_admin: "Association Admin",
    mosque_admin: "Mosque Admin",
    member: "Member",
    total_users: "Users",
    total_registrations: "Registrations",
    new_association: "New association",
    assoc_name: "Association name",
    slug: "Slug (URL)",
    admin_name: "Admin name",
    admin_email: "Admin email",
    admin_password: "Admin password",
    assigned_mosques: "Assigned mosques",
    confirm_delete: "Confirm deletion?",
    login_required: "Log in to continue",
    powered_by: "Powered by SHIALOC",
    cat_prayer: "Prayer",
    cat_lecture: "Lecture",
    cat_majlis: "Majlis",
    cat_dua: "Dua",
    cat_education: "Education",
    cat_community: "Community",
    cat_ramadan: "Ramadan",
    cat_muharram: "Muharram",
    cat_other: "Other",
    cat_madressa: "Madressa",
    cat_outing: "Outing",
    cat_sport: "Sports",
    cat_women: "Women's program",
    all_categories: "All",
    all_mosques: "All mosques",
    view_full_calendar: "View full calendar",
    event_categories_title: "Event categories",
    custom_categories_hint: "Add your own categories (e.g. Tajwid class). They appear alongside default categories in the event form.",
    category_colors_hint: "Click a swatch to set each category's color (shown on the calendar and event cards). Without a custom color, the mosque color applies.",
    new_category_placeholder: "New category...",
    add_category_btn: "Add",
    chatbot_title: "Program assistant",
    chatbot_intro: "Salam! Ask me anything about upcoming programs. For example:",
    chatbot_placeholder: "Ask your question...",
    chatbot_sugg_1: "What's the program this week?",
    chatbot_sugg_2: "Is there a majlis this weekend?",
    chatbot_sugg_3: "What are the next events?",
    chatbot_error: "Sorry, something went wrong. Please try again.",
    chatbot_view_event: "View event",
    chatbot_register: "Register",
    chatbot_registered: "Registered",
    chatbot_login_to_register: "Log in to register",
    chatbot_register_success: "Registration confirmed!",
    chatbot_unregister_success: "Registration cancelled",
    import_pdf: "Import PDF",
    import_pdf_title: "Import a PDF program",
    import_pdf_hint: "Upload your association or mosque program as a PDF (text or scanned). AI detects the events automatically — you review before creation.",
    import_select_file: "Choose a PDF file",
    import_analyzing: "AI is analyzing the PDF…",
    import_events_found: "{n} event(s) detected — review, adjust, then confirm:",
    import_shift_j1: "Shift events to the previous day (D-1) — the evening takes place the day before the listed date",
    import_no_mosque: "Create a mosque first (Mosques tab) before importing a PDF program.",
    google_sync_hint: "Calendar added! It appears under \"Other calendars\" on calendar.google.com. On the Google Calendar mobile app: Settings → your account → association name → enable sync. Events may take a few minutes to show.",
    sync_help: "Sync help",
    gcal_auto_label: "Automatic sync",
    gcal_connect: "Connect my Google Calendar",
    gcal_connected: "Google Calendar connected",
    gcal_disconnect: "Disconnect Google Calendar",
    gcal_connected_toast: "Google Calendar connected! Events are added automatically to your calendar (including on Android).",
    gcal_disconnected_toast: "Google Calendar disconnected. Synced events will be removed from your calendar.",
    gcal_error_toast: "Google connection failed. Please try again.",
    gcal_sync_now: "Resync now",
    gcal_syncing: "Syncing…",
    gcal_sync_done: "{n} event(s) synced to your Google Calendar!",
    gcal_sync_partial: "{n} event(s) synced",
    gcal_enable_assoc: "Enable sync for this association",
    follow: "Follow",
    following: "Following",
    guest_followed_toast: "Association followed — saved on this device, no account needed",
    guest_unfollowed_toast: "Association removed from your follows",
    my_followed_assocs: "My followed associations",
    guest_device_note: "Saved on this device",
    privacy_link: "Privacy policy",
    delete_all_events: "Delete all",
    delete_all_confirm: "Delete ALL events ({n})? This is irreversible and will also remove them from synced Google calendars.",
    deleted_n_events: "{n} event(s) deleted",
    copy_link: "Copy link",
    import_none_found: "No events detected in this PDF.",
    import_create_n: "Create {n} event(s)",
    import_other_file: "Another file",
    import_success: "{n} event(s) created successfully!",
    view_mosque: "View mosque",
    contact: "Contact",
    open_map: "View on map",
    back: "Back",
    full: "Full",
    visit_page: "Visit page",
    landing_footer: "Built for Shia associations, Islamic centers and mosques worldwide.",
    day: "Day",
    timeline: "Timeline",
    year: "Year",
    gallery: "Gallery",
    upload_photo: "Upload photo",
    caption: "Caption",
    no_photos: "No photos yet",
    moderator: "Moderator",
    my_profile: "My profile",
    phone_number: "Phone",
    phone_hint: "International format, e.g. +447700900123",
    notify_email_label: "Email notifications",
    push_notifications: "Push notifications (browser)",
    push_denied: "Permission denied by browser",
    notify_members_btn: "Notify members",
    notification_sent: "Notification sent to {n} member(s)",
    push_banner_text: "Never miss an event: enable push notifications.",
    push_banner_btn: "Enable",
    audience_mosque: "Mosque followers",
    audience_all: "Whole association",
    reminder_hint: "Registered members get an automatic reminder 1 hour before the event.",
    feed: "Feed",
    announcement: "Announcement",
    photo: "Photo",
    write_comment: "Write a comment...",
    comments: "Comments",
    no_feed_title: "Your feed is empty",
    no_feed_text: "Join an association to see its events, announcements and photos here.",
    become_member: "Become a member",
    mosque_member: "Member",
    mosque_members: "mosque members",
    mosque_member_singular: "mosque member",
    following_success: "You are now a member of this mosque. You will receive its notifications.",
    unfollowed: "You no longer follow this mosque.",
    post: "Post",
    post_placeholder: "Share an update with your members...",
    publish: "Publish",
    post_published: "Post added to the feed",
    post_deleted: "Post deleted",
    all_members: "All members",
    no_members_yet: "No members yet",
    my_mosque: "My mosque",
    other_mosques: "Other mosques",
    next_event: "Next event",
    no_upcoming_event: "No upcoming event",
    prayer_times: "Prayer times",
    prayer_fajr: "Fajr",
    prayer_sunrise: "Sunrise",
    prayer_dhuhr: "Dhuhr",
    prayer_asr: "Asr",
    prayer_maghrib: "Maghrib",
    prayer_isha: "Isha",
    forgot_password: "Forgot password?",
    forgot_password_title: "Reset password",
    forgot_password_text: "Enter your email and we'll send you a reset link valid for 1 hour.",
    send_reset_link: "Send link",
    reset_sent: "If an account exists with this email, a reset link has been sent. Check your inbox.",
    new_password: "New password",
    admin_accounts: "Admin accounts",
    change_password_btn: "Change password",
    password_updated: "Password updated!",
    pwd_min_hint: "Min 8 characters",
    role_association_admin: "Association admin",
    role_mosque_admin: "Mosque manager",
    confirm_password: "Confirm password",
    passwords_mismatch: "Passwords do not match",
    reset_success: "Password reset! You can now log in.",
    reset_password_btn: "Reset",
    reset_link_invalid: "Invalid or incomplete link. Please make a new request.",
    back_to_login: "Back to login",
    event_banners: "Banners (one or more images)",
    add_image: "Add image",
    main_image: "Main",
    timezone_search: "Search a timezone...",
    no_results: "No results",
    invite_members: "Invite",
    invite_message: "Join {name} on SHIALOC! Community events, prayer times and news:",
    invite_dialog_text: "Share {name}'s link with your friends and family.",
    copy_link: "Copy link",
    error_generic: "Something went wrong",
    join_mosque_prompt: "Create an account or log in to become a member of {name}.",
    social_links: "Social media",
    gps_coords: "GPS coordinates",
    gps_hint: "Used for accurate prayer times based on the exact location.",
    live_broadcast: "Live broadcast",
    watch_on: "Watch on {platform}",
    notify_live: "Notify live",
    live_notified: "{count} members notified about the live!",
    guest_interact_prompt: "Create an account to interact with the community",
    choose_continue: "How would you like to continue?",
    continue_guest: "Continue as guest",
    guest_desc: "Browse associations, mosques, events and prayer times without an account.",
    login_or_register: "Log in or create an account",
    member_desc: "Become a member: likes, comments, event registrations and notifications.",
    register_association: "Register my association",
    register_association_cta_desc: "Your association is not on SHIALOC yet? Submit a request.",
    register_association_title: "Register your association",
    register_association_sub: "Fill in this form. The super administrator will review your request, then you can log in with your credentials.",
    your_credentials: "Your login credentials (after approval)",
    message_optional: "Message (optional)",
    send_request: "Send request",
    assoc_request_sent_title: "Request sent!",
    assoc_request_sent_text: "Your request has been sent to the super administrator. Once approved, you can log in with the email and password you chose.",
    pending_requests: "Registration requests",
    approve: "Approve",
    reject: "Reject",
    request_approved: "Request approved — association created",
    request_rejected: "Request rejected",
    req_pending: "Pending",
    req_approved: "Approved",
    req_rejected: "Rejected",
    account_user: "User",
    account_assoc: "Association",
    mosque_manager: "Manager",
    designate_manager: "Designate a manager",
    designate_manager_hint: "A 'Mosque admin' account will be created with these credentials. If the email already belongs to a manager of your association, this mosque will simply be added to them (password ignored).",
    manager_designated: "Manager designated!",
  },
};

export const CATEGORIES = ["prayer", "lecture", "majlis", "dua", "education", "community", "ramadan", "muharram", "madressa", "outing", "sport", "women", "other"];

export const catLabel = (t, key) => (CATEGORIES.includes(key) ? t(`cat_${key}`) : (key || t("cat_other")));

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("shialoc-lang") || "fr");
  const setLang = useCallback((l) => {
    localStorage.setItem("shialoc-lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((key) => translations[lang]?.[key] ?? translations.fr[key] ?? key, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
